const partlyCloudy = ['09-22-06_0732.JPG',
'10-03-07_1823.JPG',
'10-26-05_1759.JPG',
'11-03-05_1646.JPG',
'11-13-05_1626.JPG',
'12-03-06_1611.JPG',
'19-06-08_2010.JPG',
'IMG_0074.JPG',
'IMG_0080.JPG',
'IMG_0095.JPG',
'IMG_0096.JPG',
'IMG_0097.JPG',
'IMG_0104.JPG',
'IMG_0114.JPG',
'IMG_0122.JPG',
'IMG_0126.JPG',
'IMG_0127.JPG',
'IMG_0132.JPG',
'IMG_0133.JPG',
'IMG_0134.JPG',
'IMG_0135.JPG',
'IMG_0136.JPG',
'IMG_0151.JPG',
'IMG_0152.JPG',
'IMG_0153.JPG',
'IMG_0158.JPG',
'IMG_0159.JPG',
'IMG_0160.JPG',
'IMG_0396.JPG',
'IMG_0397.JPG',
'IMG_0398.JPG',
'IMG_0399.JPG',
'IMG_0401.JPG',
'IMG_0408.JPG',
'IMG_0415.JPG',
'IMG_0497.JPG',
'IMG_0558.JPG',
'IMG_0614.JPG',
'IMG_0639.JPG',
'IMG_0641.JPG',
'IMG_0915.JPG',
'IMG_0933.JPG',
'IMG_0939.JPG',
'IMG_0946.JPG',
'IMG_0960.JPG',
'IMG_0963.JPG',
'IMG_1160.JPG',
'IMG_1330.JPG',
'IMG_1453.JPG',
'IMG_1467.JPG',
'IMG_1539.JPG',
'IMG_1552.JPG',
'IMG_1591.JPG',
'IMG_1592.JPG',
'IMG_1600.JPG',
'IMG_1602.JPG',
'IMG_1603.JPG',
'IMG_1631.JPG',
'IMG_1633.JPG',
'IMG_1740.JPG',
'IMG_1779.JPG',
'IMG_1780.JPG',
'IMG_1785.JPG',
'IMG_1796.JPG',
'IMG_1800.JPG',
'IMG_1818.JPG',
'IMG_1823.JPG',
'IMG_1946.JPG',
'IMG_1947.JPG',
'IMG_2029.JPG',
'IMG_2244.JPG',
'IMG_2289.JPG',
'IMG_2295.JPG',
'IMG_2296.JPG',
'IMG_2305.JPG',
'IMG_2306.JPG',
'IMG_2312.JPG',
'IMG_2330.JPG',
'IMG_2400.JPG',
'IMG_2462.JPG',
'IMG_2514.JPG',
'IMG_2515.JPG',
'IMG_2539.JPG',
'IMG_2546.JPG',
'IMG_2556.JPG',
'IMG_2559.JPG',
'IMG_2567.JPG',
'IMG_2571.JPG',
'IMG_2575.JPG',
'IMG_2585.JPG',
'IMG_2592.JPG',
'IMG_2594.JPG',
'IMG_2598.JPG',
'IMG_2613.JPG',
'IMG_2635.JPG',
'IMG_2757.JPG',
'IMG_2809.JPG',
'IMG_2813.JPG',
'IMG_2814.JPG',
'IMG_2840.JPG',
'IMG_2861.JPG',
'IMG_2878.JPG',
'IMG_2967.JPG',
'IMG_2969.JPG',
'IMG_2983.JPG',
'IMG_3127.JPG',
'IMG_3128.JPG',
'IMG_3172.JPG',
'IMG_3177.JPG',
'IMG_3270.JPG',
'IMG_3449.JPG',
'IMG_3550.JPG',
'IMG_3608.JPG',
'IMG_3621.JPG',
'IMG_3629.JPG',
'IMG_3646.JPG',
'IMG_3700.JPG',
'IMG_3701.JPG',
'IMG_3703.JPG',
'IMG_3749.JPG',
'IMG_3828.JPG',
'IMG_3840.JPG',
'IMG_3909.JPG',
'IMG_4229.JPG',
'IMG_4272.JPG',
'IMG_4273.JPG',
'IMG_4274.JPG',
'IMG_4276.JPG',
'IMG_4286.JPG',
'IMG_4357.JPG',
'IMG_4381.JPG',
'IMG_4406.JPG',
'IMG_4408.JPG',
'REBELXS_IMG_0067.JPG',
'REBELXS_IMG_0301.JPG',
'REBELXS_IMG_0311.JPG',
'REBELXS_IMG_0316.JPG',
'REBELXS_IMG_0340.JPG',
'REBELXS_IMG_0408.JPG',
'REBELXS_IMG_0447.JPG',
'REBELXS_IMG_0831.JPG',
'REBELXS_IMG_0890.JPG',
'REBELXS_IMG_0908.JPG',
'REBELXS_IMG_0954.JPG',
'REBELXS_IMG_0973.JPG',
'REBELXS_IMG_1649.JPG',
'REBELXS_IMG_1650.JPG',
'REBELXS_IMG_1954.JPG',
'REBELXS_IMG_1964.JPG',
'REBELXS_IMG_1969.JPG',
'REBELXS_IMG_1987.JPG',
'REBELXS_IMG_1990.JPG',
'REBELXS_IMG_1991.JPG',
'REBELXS_IMG_2427.JPG',
'REBELXS_IMG_2554.JPG',
'REBELXS_IMG_2600.JPG',
'REBELXS_IMG_2677.JPG',
'REBELXS_IMG_2779.JPG',
'REBELXS_IMG_2780.JPG',
'REBELXS_IMG_2781.JPG',
'REBELXS_IMG_3196.JPG',
'REBELXS_IMG_3264.JPG',
'REBELXS_IMG_3462.JPG',
'REBELXS_IMG_3463.JPG',
'REBELXS_IMG_3467.JPG',
'REBELXS_IMG_3468.JPG',
'STC_3239.JPG',
'STG_3243.JPG',
'STJ_2323.JPG',
'IPHONE2G_IMG_0001.JPG',
'IPHONE2G_IMG_0044.JPG',
'IPHONE2G_IMG_0056.JPG',
'IPHONE2G_IMG_0109.JPG',
'IPHONE2G_IMG_0185.JPG',
'IPHONE2G_IMG_0211.JPG',
'IPHONE2G_IMG_0242.JPG',
'IPHONE2G_IMG_0251.JPG',
'IPHONE2G_IMG_0352.JPG',
'IPHONE2G_IMG_0453.JPG'];

export default partlyCloudy;